import {OutlinedInput, OutlinedInputProps} from '@mui/material';

export const UiTextInput = (props: OutlinedInputProps) => {
    return <OutlinedInput
        className={cmpClass}
        {...props}
    />;
};

const cmpClass = 'ui-text-input';
